import { injectable } from "@launchtray/tsyringe-async";
import { Event } from "event-system";
import { IGameDistributionSdk } from "./interfaces/IGameDistributionSdk";
import { TickerModel } from "../common/models/TickerModel";

@injectable()
export class DummySdkWrapper implements IGameDistributionSdk {
    public readonly pauseAudio: Event;
    public readonly resumeAudio: Event;

    private isPrerollActive: boolean = true;

    public constructor(private readonly tickerModel: TickerModel) {
        this.pauseAudio = new Event();
        this.resumeAudio = new Event();
    }

    public async initialize(): Promise<void> {
    }

    public showRewardedAd(): Promise<boolean> {
        return new Promise(resolve => {
            this.adGamePause();
            setTimeout(() => {
                this.adGameStart();
                console.log("Rewarded ad finished");
                resolve(true);
            }, 2000);
        });
    }

    public async showPrerollAd(): Promise<void> {
        if (this.isPrerollActive) {
            console.log("Preroll ad finished");
            this.isPrerollActive = false;
        }
    }
    public async showMidrollAd(): Promise<void> {
        console.log("Midroll ad finished");
    }

    private adGamePause(): void {
        this.pauseAudio.emit();
        this.tickerModel.onPauseRequest();
    }

    private adGameStart(): void {
        this.resumeAudio.emit();
        this.tickerModel.onResumeRequest();
    }

}
